import createIcon from '../../createIcon';

/**
 * @component @name DataSaverOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMi4wMjUzOVY1LjA1NTM5QzE2LjM5IDUuNTQ1MzkgMTkgOC40NDUzOSAxOSAxMS45NzU0QzE5IDEyLjg3NTQgMTguODIgMTMuNzI1NCAxOC41MiAxNC41MTU0TDIxLjEyIDE2LjA0NTRDMjEuNjggMTQuODA1NCAyMiAxMy40MjU0IDIyIDExLjk3NTRDMjIgNi43OTUzOSAxOC4wNSAyLjUyNTM5IDEzIDIuMDI1MzlaTTEyIDE4Ljk3NTRDOC4xMyAxOC45NzU0IDUgMTUuODQ1NCA1IDExLjk3NTRDNSA4LjQ0NTM5IDcuNjEgNS41NDUzOSAxMSA1LjA1NTM5VjIuMDI1MzlDNS45NCAyLjUyNTM5IDIgNi43ODUzOSAyIDExLjk3NTRDMiAxNy40OTU0IDYuNDcgMjEuOTc1NCAxMS45OSAyMS45NzU0QzE1LjMgMjEuOTc1NCAxOC4yMyAyMC4zNjU0IDIwLjA1IDE3Ljg4NTRMMTcuNDUgMTYuMzU1NEMxNi4xNyAxNy45NTU0IDE0LjIxIDE4Ljk3NTQgMTIgMTguOTc1NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataSaverOff = createIcon('DataSaverOff', [
  [
    'path',
    {
      d: 'M13 2.02539V5.05539C16.39 5.54539 19 8.44539 19 11.9754C19 12.8754 18.82 13.7254 18.52 14.5154L21.12 16.0454C21.68 14.8054 22 13.4254 22 11.9754C22 6.79539 18.05 2.52539 13 2.02539ZM12 18.9754C8.13 18.9754 5 15.8454 5 11.9754C5 8.44539 7.61 5.54539 11 5.05539V2.02539C5.94 2.52539 2 6.78539 2 11.9754C2 17.4954 6.47 21.9754 11.99 21.9754C15.3 21.9754 18.23 20.3654 20.05 17.8854L17.45 16.3554C16.17 17.9554 14.21 18.9754 12 18.9754Z',
      key: '1huc1q',
    },
  ],
]);

export default DataSaverOff;
